import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "flex flex-wrap h-full content-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");
  const _directive_loading = _resolveDirective("loading");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.imgList, (items, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "flex h-1/2 justify-center content-center"
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (itemOne, indexOne) => {
      return _openBlock(), _createBlock(_component_el_image, {
        key: indexOne,
        class: "p-1 w-auto",
        src: itemOne,
        fit: 'contain',
        "initial-index": index + indexOne + index,
        "preview-src-list": [...$setup.imgList[0], ...$setup.imgList[1]]
      }, null, 8, ["src", "initial-index", "preview-src-list"]);
    }), 128))]);
  }), 128))])), [[_directive_loading, $setup.loading]]);
}